<template>
    <el-dialog
        :title="'Option (' + thisoption.slug + ')'"
        :visible.sync="thisvisible"
    >
        <div class="form-container">
            <div v-loading="loading" class="form-container">
                <el-form
                    ref="optionForm"
                    :model="thisoption"
                    :rules="rules"
                    style="width: 100%;"
                >
                    <el-form-item
                        v-if="!thisoption.id"
                        label="Slug"
                        prop="slug"
                        :error="getErrorForField('slug', errors)"
                    >
                        <el-input v-model="thisoption.slug" />
                    </el-form-item>
                    <el-form-item
                        label="Étape"
                        prop="etape"
                        :error="getErrorForField('etape', errors)"
                    >
                        <el-input v-model="thisoption.etape" />
                    </el-form-item>
                    <el-form-item
                        label="Description"
                        prop="description"
                        :error="getErrorForField('description', errors)"
                    >
                        <el-input
                            type="textarea"
                            :rows="2"
                            v-model="thisoption.description"
                        />
                    </el-form-item>
                    <el-form-item
                        label="Contenu"
                        prop="data"
                        :error="getErrorForField('data', errors)"
                    >
                        <el-input
                            type="textarea"
                            :rows="5"
                            v-model="thisoption.data"
                        />
                    </el-form-item>
                    <el-form-item>
                        <el-button type="info" @click="thisvisible = false">
                            Annuler
                        </el-button>
                        <el-button
                            v-if="!thisoption.excel"
                            type="primary"
                            @click="save"
                        >
                            Enregistrer
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import Resource from "@/api/resource";
const optionResource = new Resource("options");

export default {
    name: "Option",
    props: {
        isvisible: {
            type: Boolean,
            default: false
        },
        option: {
            type: Object,
            default: () => {
                return {
                    slug: "",
                    description: "",
                    data: ""
                };
            }
        },
        parent: {
            type: Object
        }
    },
    data() {
        return {
            thisvisible: false,
            loading: false,
            rules: {
                slug: {},
                etape: {},
                description: {},
                data: {}
            },
            errors: [],
            thisoption: {
                slug: "",
                etape: "",
                description: "",
                data: ""
            }
        };
    },
    watch: {
        isvisible(val) {
            if (val) {
                this.thisvisible = val;
                this.errors = [];
                if (this.option) {
                    Object.assign(this.thisoption, this.option);
                }
            }
        },
        thisvisible(val) {
            if (!val) {
                this.parent.dialogOptionVisible = val;
                this.errors = [];
            }
        }
    },
    computed: {},

    methods: {
        save() {
            this.errors = [];
            this.loading = true;
            if (this.thisoption.id) {
                optionResource
                    .update(this.thisoption.id, this.thisoption)
                    // .then(response => {
                    .then(response => {
                        this.loading = false;
                        this.parent.callbackOption(true, response.data);
                        this.thisvisible = false;
                        this.$message({
                            message: "Option mise à jour",
                            type: "success",
                            duration: 5 * 1000
                        });
                    })
                    .catch(error => {
                        if (error.response && error.response.data) {
                            this.errors = error.response.data.errors;
                        }
                        console.log("error");
                        console.log(error.response);
                        this.loading = false;
                    });
            } else {
                optionResource
                    .store(this.thisoption)
                    .then(response => {
                        this.loading = false;
                        this.thisvisible = false;
                        this.$message({
                            message: "Option créée",
                            type: "success",
                            duration: 5 * 1000
                        });
                        console.log(response);
                        this.parent.callbackOption(true, false);
                    })
                    .catch(error => {
                        if (error.response && error.response.data) {
                            this.errors = error.response.data.errors;
                        }
                        console.log("error");
                        console.log(error.response);
                        this.loading = false;
                    });
            }
        },
        getErrorForField(field, errors) {
            if (errors && errors[field]) {
                return errors[field].join(" ");
            }
        }
    }
};
</script>
